/* eslint-disable no-shadow */
import DateTimeHandler from "@/services/common/date-time/DateTimeHandlerService";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api/index";
import {
		 CloseDialogTriggeredSignal,
		 GetRecordersIdsError,
		 GetRecordersIdsSuccess,
		 GetSignalRegisters,
		 GetSignalRegistersError,
		 GetSignalRegistersSuccess,
		 OpenDialogTriggeredSignal,
} from "@/stores/actions/TriggeredSignal";

const Qs = require("qs");

/**
* @summary Atribui a um Array objetos que contém o nomes do gatilho, data  e id dos registros.
* @type {function}
* @return {Array[Object]} Um array de objetos que contém  Id, nome e gatilhos.
*/
const SetDataTable = (registers) =>
{
	const registersDataTable = [];

	for (let i = 0; i < registers.length; i++)
	{
		const register = {
			id:   0, name: "", date: "",
		};
		register.id = registers[i].id;
		register.name = registers[i].name;
		register.date = DateTimeHandler.ToLocalDateTime(registers[i].date);
		registersDataTable.push(register);
	}
	return registersDataTable;
};

const state = {
	dialog:                  false,
	getSignalRegistersError: {},
	registers:               [],
	status:                  "",
	getRecordersIdsError:    {},
	recordersIds:            [],
	getRecordersIdsStatus:   "",
	tableData:               [],
};

const actions = {
	[OpenDialogTriggeredSignal]: ({ commit }) =>
	{
		commit(OpenDialogTriggeredSignal);
	},
	[CloseDialogTriggeredSignal]: ({ commit }) =>
	{
		commit(CloseDialogTriggeredSignal);
	},
	[GetSignalRegisters]: ({ commit }, parameters) =>
	{
		commit(GetSignalRegisters);
		http.get(`/SignalRegisters/${parameters.monitoringElement}`, {
			params:           parameters,
			paramsSerializer: params => Qs.stringify(params, { allowDots: true, arrayFormat: "indices" }),
		})
			.then((resp) =>
			{
				if (resp.status !== 200)
				{
					commit(GetSignalRegistersError, resp.status);
				}
				else
				{
					const registers = SetDataTable(resp.data);
					commit(GetSignalRegistersSuccess, registers);
				}
			})
			.catch((error) =>
			{
				commit(GetSignalRegistersError, error.response.status);
			});
	},
};

const mutations = {
	[OpenDialogTriggeredSignal]: (state) =>
	{
		state.dialog = true;
	},
	[CloseDialogTriggeredSignal]: (state) =>
	{
		state.dialog = false;
	},
	[GetRecordersIdsError]: (state, error) =>
	{
		state.getRecordersIdsError = error.resp;
		state.getRecordersIdsStatus = FetchStatus.Error;
	},
	[GetRecordersIdsSuccess]: (state, resp) =>
	{
		state.recordersIds = resp.data;
		state.getRecordersIdsStatus = FetchStatus.Loaded;
	},
	[GetSignalRegistersError]: (state, error) =>
	{
		state.GetSignalRegisterError = error;
		state.status = FetchStatus.Error;
	},
	[GetSignalRegisters]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GetSignalRegistersSuccess]: (state, registers) =>
	{
		state.registers = registers;
		state.status = FetchStatus.Loaded;
	},
};

export default {
	state,
	actions,
	mutations,
};
